export const ACTIONS = {
  FETCH_USER: 'SERVICE_ACCOUNT__FETCH_USER',
  SET_CHANGE_PASSWORD: 'SERVICE_ACCOUNT__SET_CHANGE_PASSWORD',
  SET_UPDATE_USER_PROFILE: 'SERVICE_ACCOUNT__SET_UPDATE_USER_PROFILE',
};
